/* eslint-disable global-require */
import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import noLocaleData from 'react-intl/locale-data/no';
import Stats from './views/stats/Stats';
import Portfolio from './views/portfolio/Portfolio';
import Home from './views/home/Home';
import Login from './views/login/Login';
import NotFound from './views/not-found/NotFound';
import Search from './views/search/Search';
import Members from './views/members/Members';
import Crypto from './views/crypto/Crypto';
import PageWrapper from './views/PageWrapper';
import PrivacyPolicy from './views/privacy-policy/PrivacyPolicy';

addLocaleData(noLocaleData);

export default class StockwatchRouter extends Component {
  render() {
    return (
      <IntlProvider locale="no">
        <BrowserRouter>
          <Switch>
            <Route
              path="/"
              exact
              render={props => (
                <PageWrapper
                  {...props}
                  component={Home}
                  pageName="$tockwatch"
                />
              )}
            />
            <Route
              path="/stats"
              render={props => (
                <PageWrapper
                  {...props}
                  component={Stats}
                  pageName="Statistikk"
                  requireLogin
                />
              )}
            />
            <Route
              path="/portefolje"
              render={props => (
                <PageWrapper
                  {...props}
                  component={Portfolio}
                  pageName="Portefølje"
                  requireLogin
                />
              )}
            />
            <Route
              path="/sok"
              render={props => (
                <PageWrapper
                  {...props}
                  component={Search}
                  pageName="Fond/Aksjer/ETF"
                  requireLogin
                />
              )}
            />
            <Route
              path="/crypto"
              render={props => (
                <PageWrapper
                  {...props}
                  component={Crypto}
                  pageName="Crypto"
                  requireLogin
                />
              )}
            />
            <Route
              path="/medlemmer"
              render={props => (
                <PageWrapper
                  {...props}
                  component={Members}
                  pageName="Medlemmer"
                  requireLogin
                />
              )}
            />
            <Route
              path="/logg-inn"
              render={props => (
                <PageWrapper {...props} component={Login} pageName="Logg inn" />
              )}
            />
            <Route
              path="/logg-ut"
              render={props => (
                <PageWrapper {...props} logout pageName="Logg inn" />
              )}
            />
            <Route
              path="/privacy-policy"
              render={props => (
                <PageWrapper
                  {...props}
                  component={PrivacyPolicy}
                  pageName="Personvernerklæring"
                />
              )}
            />
            <Route
              path="*"
              render={props => (
                <PageWrapper
                  {...props}
                  component={NotFound}
                  pageName="Ikke funnet"
                />
              )}
            />
          </Switch>
        </BrowserRouter>
      </IntlProvider>
    );
  }
}
